var render = function render(){var _vm=this,_c=_vm._self._c;return (
        _vm.showItemDynamically(_vm.user, _vm.dynamicViewsConstants.resource_names.RENT_TARIFF, ['index']) &&
        !_vm.showItemDynamically(_vm.user, _vm.dynamicViewsConstants.resource_names.DOCKING_STATION, ['show_statistics', 'index'])
    )?_c('el-menu-item',{attrs:{"index":"/rent_tariffs"}},[_c('div',{staticClass:"img-wrapper"},[_c('img',{attrs:{"src":require("@src/assets/sidebar/stations.svg")}})]),_c('router-link',{staticClass:"sub-menu-link",attrs:{"to":"/rent_tariffs"}},[_c('span',[_vm._v(" "+_vm._s(_vm.$t('sidebar.rent_tariffs')))])])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }